import fetch, { NewAxiosRequestConfig } from '@/utils/axios';

/**
 * 获取promotion活动信息
 * @param config
 */
export const getPromotion = (productId: number, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/promotion/promotions/product/${productId}`, null, config);
};

/**
 * 获取promotion v2活动信息
 * @param config
 */
export const getPromotionV2 = (productId: number, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/promotion/promotions/product/${productId}/v2`, null, config);
};

/**
 * 获取promotion弹窗信息
 * @param config
 */
export const getPromotionInfo = (params, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(
    `/ec/promotion/promotions/product/${params.productId}/price?trigger_type=${params.trigger_type}`,
    config
  );
};

/**
 * 凑单活动信息
 * @param params
 * @param config
 * @returns
 */
export const getCombinePurchaseInfo = (
  params: {
    promo_type: string;
    promo_id: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/promotion/promotions/info?promo_type=${params.promo_type}&promo_id=${params.promo_id}`, config);
};

/**
 * 接口迁移，account获取coupon列表
 * @param params
 * @param config
 * @returns
 */
export const getAccountCoupon = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/promotion/coupon/list`, params, config);
};

/**
 * 优惠券重构，新接口查询coupon信息
 * @param params
 * @param config
 * @returns
 */
export const getCounponInfo = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/promotion/coupon/claim/collection/query`, params, config);
};

/**
 * ftu弹框背景图
 * @param params
 * @param config
 * @returns
 */
export const getFtuBgInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/promotion/promotions/anonymous_user_gift_v2`, params, config);
};

/**
 * 匿名用户礼品配置（如 onboarding 底部 banner）
 */
export const getAnonymousUserGift = (
  params: { source: string; user_type?: string } & ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/promotion/promotions/anonymous_user_gift`, params, config);
};

/**
 * 优惠券组件 点击领取coupon
 * @param params
 * @param config
 * @returns
 */
export const claimCoupon = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/promotion/coupon/cms/claim/batch`, params, config);
};

/**
 * 领取mkpl商家优惠券
 * @param params
 * @param config
 */
export const claimMkplVendorCoupon = (
  params: {
    vendor_id: string | number;
    plan_id: string | number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post(`/ec/promotion/mkpl/coupon/obtain`, params, config);
};

/**
 * mkpl sku level coupon
 * @param params
 * @param config
 * @returns
 */
export const getMkplSkuCouponInfoInPdp = (
  params: {
    product_id: string | number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/promotion/mkpl/coupon/product/${params.product_id}`, {}, config);
};

export const getMkplSkuCouponDetailInfo = (
  params: {
    plan_id: string | number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/promotion/mkpl/coupon/product/plan/${params.plan_id}`, {}, config);
};

/**
 * 获取raffle landing数据
 * @param params
 * @param config
 * @returns
 */
export const getRaffleLandingInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/promotion/raffle/homepage`, params, config);
};

/**
 * 订单成功后获得抽奖机会
 * @param params
 * @param config
 * @returns
 */
export const queryRaffleRewards = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/promotion/raffle/rewards/success`, params, config);
};

/**
 * 分享增加用户抽奖次数
 * @param params
 * @param config
 * @returns
 */
export const updateRaffleChance = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/promotion/raffle/share/chance`, params, config);
};

export const getTopMsgV3Data = (url: string) => {
  return fetch.get(url);
};

export const getPromotionLandingInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/promotion/promotions/landing`, params, config);
};

export const giftCardResendEmail = (
  params: { order_id: string; email: string; phone: string; sender_message: string; sender_name: string },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post(`/ec/promotion/giftcard/resend/email`, params, config);
};

/**
 * Gift Card Landing信息
 * @param params
 * @param config
 * @returns
 */
export const getGiftCardLandingInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/promotion/giftcard/landing/info`, params, config);
};

/**
 * Gift Card Redeem信息
 * @param params
 * @param config
 * @returns
 */
export const getGiftCardRedeemInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/promotion/giftcard/redeem/info`, params, config);
};

/**
 * Gift Card 兑换
 * @param params
 * @param config
 * @returns
 */
export const getGiftCardRedeem = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/promotion/giftcard/redeem`, params, config);
};

/**
 * 印度Diwali活动，获取优惠券信息
 * @param params
 * @param config
 * @returns
 */
export const queryCouponInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/promotion/coupon/foundation/list`, params, config);
};

/*
  获取fbw landing页面信息
*/
export const getFbwPersonalModule = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/promotion/promotions/personal/module`, params, config);
};

/*
  获取fbw landing页面查看更多信息
*/
export const getFbwModuleMore = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/promotion/promotions/personal/module`, params, config);
};

/*
  coupon landing页领取商品接口
*/
export const claimCouponLandingProduct = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/promotion/targeting/claim`, params, config);
};
